import React, { lazy } from 'react'
import Loadable from '../../components/Loadable/Loadable'
import { Page } from '../../Pages'
import { ShowIfRole } from '../../auth/AuthGuard'
import { accessRights, authRoles } from '../../auth/authRoles'

const DashboardsPage = Loadable(lazy(() => import('./DashboardsPage')))
const DashboardsPageImpl = Loadable(lazy(() => import('./DashboardsPageImpl')))

const dashboardsRoutes = [
	{
		path: Page.dashboard.path,
		children: [
			{
				path: ':idUser',
				element: (
					<ShowIfRole role={authRoles.admin}>
						<DashboardsPageImpl />
					</ShowIfRole>
				)
			},
			{
				path: 'byFlat/',
				children: [
					{
						path: ':idFlat',
						element: (
							<ShowIfRole role={accessRights.housingCooper}>
								<DashboardsPageImpl />
							</ShowIfRole>
						)
					}
				]
			},
			{
				path: '',
				element: <DashboardsPage />
			}
		]
	}
]

export default dashboardsRoutes
